import moment from "moment";
import { create } from "zustand";

interface DashboardState {
  selectedBookingDate: moment.Moment;

  setSelectedBookingDate: (date: moment.Moment) => void;
}

const useDashboardStore = create<DashboardState>((set) => ({
  selectedBookingDate: moment(),

  setSelectedBookingDate: (date) => set({ selectedBookingDate: date }),
}));
export default useDashboardStore;
